import { sharedStyles } from "@certn/cascadia-react/components/inputs/styles";
import { getTextStyle } from "@certn/cascadia-react/foundations/typography/styles";
import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Switch as AriaSwitch, SwitchProps } from "react-aria-components";

import { SwitchAsset } from "./SwitchAsset";
import { Text } from "./Text";

interface Props extends SwitchProps {
  card?: boolean;
  strong?: boolean;
  helpText?: string;
  testID?: string;
}

export function Switch(props: Props) {
  const {
    card,
    helpText,
    strong = helpText !== undefined || card,
    testID = "switch",
    ...switchProps
  } = props;

  const className = css(
    styles.switch,
    strong && getTextStyle("input/label"),
    card && sharedStyles.card
  );

  return (
    <AriaSwitch {...mergeProps(switchProps, { className })}>
      {(renderProps) => {
        return (
          <>
            <SwitchAsset
              {...renderProps}
              isFocused={card ? false : renderProps.isFocused}
              isFocusVisible={card ? false : renderProps.isFocusVisible}
              testID={testID}
            />
            <div className={css(styles.text)}>
              {typeof props.children === "function"
                ? props.children(renderProps)
                : props.children}
              {props.helpText && (
                <Text style="input/helper" color="text-weak">
                  {props.helpText}
                </Text>
              )}
            </div>
          </>
        );
      }}
    </AriaSwitch>
  );
}

const styles = {
  switch: css(
    {
      position: "relative",
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      gap: "var(--space-2)",
      paddingBottom: "var(--space-1)",
      paddingTop: "var(--space-1)",
    },
    getTextStyle("form/body-secondary")
  ),
  text: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  }),
};
